import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CalendarDays, MapPin, Ticket, Users } from "lucide-react";
import { api, fileUrl, fmtDate } from "@/lib/api";
import { Navbar } from "@/components/landing/Hero";
import { CoverImage } from "@/components/CoverImage";

export default function EventList() {
  const [events, setEvents] = useState(null);

  useEffect(() => {
    api.get("/public/ticketing/events").then((r) => setEvents(r.data)).catch(() => setEvents([]));
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-slate-50" data-testid="public-event-page">
      <Navbar />
      <section className="relative overflow-hidden bg-slate-900 text-white pt-36 pb-24 px-6">
        <div className="absolute inset-0 bg-gradient-to-br from-indigo-900/80 via-slate-900 to-blue-900/70" />
        <div className="absolute -top-20 -right-16 w-72 h-72 rounded-full bg-indigo-600/20 blur-2xl" />
        <div className="relative max-w-4xl mx-auto text-center">
          <span className="inline-flex items-center gap-2 bg-white/10 border border-white/20 backdrop-blur-md rounded-full px-4 py-2 text-xs font-bold uppercase tracking-[0.2em] text-amber-300">
            <Ticket className="w-4 h-4" /> Event & Tiketing
          </span>
          <h1 className="mt-6 text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight" data-testid="event-list-title">Event GIM Church</h1>
          <p className="mt-5 max-w-2xl mx-auto text-base md:text-lg text-slate-300 leading-relaxed font-light">
            Daftar & amankan tiket Anda — terbuka untuk siapa saja, tidak perlu menjadi jemaat terdaftar.
          </p>
        </div>
      </section>

      <section className="max-w-6xl mx-auto px-6 -mt-14 relative z-10 pb-20">
        {events === null ? (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {[1, 2, 3].map((i) => <div key={i} className="h-72 rounded-3xl bg-slate-200 animate-pulse" />)}
          </div>
        ) : events.length === 0 ? (
          <div className="bg-white rounded-3xl p-14 text-center border border-slate-100 shadow-sm" data-testid="event-list-empty">
            <Ticket className="w-10 h-10 mx-auto text-slate-300" />
            <p className="mt-4 font-bold text-slate-900">Belum ada event dengan tiketing publik saat ini</p>
            <p className="mt-1 text-sm text-slate-500">Pantau terus halaman ini untuk event terbaru.</p>
          </div>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="event-list-grid">
            {events.map((e) => (
              <Link key={e.id} to={`/event/${e.id}`} data-testid={`event-card-${e.id}`}
                className="group bg-white rounded-3xl overflow-hidden border border-slate-100 shadow-sm hover:-translate-y-1 hover:shadow-xl transition duration-300">
                <CoverImage src={fileUrl(e.image_url)} alt={e.title} className="aspect-[4/3]" />
                <div className="p-5">
                  {e.category && <span className="inline-block text-[10px] font-bold uppercase tracking-wider text-indigo-600 bg-indigo-50 rounded-full px-2.5 py-1">{e.category}</span>}
                  <p className="mt-2 font-extrabold text-slate-900 leading-snug group-hover:text-indigo-600 transition">{e.title}</p>
                  <p className="mt-2 text-xs text-slate-500 flex items-center gap-1.5"><CalendarDays className="w-3.5 h-3.5" />{fmtDate(e.start_date, { weekday: "long", day: "numeric", month: "long" })} · {e.time}</p>
                  {e.location && <p className="mt-1 text-xs text-slate-500 flex items-center gap-1.5"><MapPin className="w-3.5 h-3.5" />{e.location}</p>}
                  <div className="mt-3 flex items-center justify-between">
                    <span className="text-sm font-black text-slate-900">{e.price ? `Rp ${e.price.toLocaleString("id-ID")}` : "Gratis"}</span>
                    <span className="text-[11px] text-slate-400 flex items-center gap-1"><Users className="w-3.5 h-3.5" />{e.registrations}{e.quota ? `/${e.quota}` : ""}</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
